const warningModelActionTypes = {
  SHOW_MODEL: 'SHOW_MODEL',
  CLOSE_MODEL: 'CLOSE_MODEL',
};

export default warningModelActionTypes;
